<template>
    <div class="container-fluid">
        <el-container>
            <el-header height="15%">
                <div class="row mt-6">
                    <div class="col-md-4">
                        <h4>Транспортные компании</h4>
                    </div>
                    <div class="col-md-2">
                        <el-button type="success" @click="goToPage('transport-companies/create')">Добавить транспортную компанию</el-button>
                    </div>
                </div>
            </el-header>
            <el-main height="80%">
                <el-form aria-label="Поиск" >
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="Поиск по названию">
                                <el-col :span="14">
                                    <el-input v-model="query.q" @change="setQueryReset"></el-input>
                                </el-col>

                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="Сортировка">
                                <el-select
                                v-model="query.sort"
                                :width="300"
                                @change="setQuery">
                                    <el-option
                                      v-for="(item, index) in sortConfig"
                                      :key="index"
                                      :value="item.field"
                                      :label="item.title"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
                <el-table
                  :data="items"
                  style="width: 100%"
                  empty-text="Нет даных"
                >
                    <el-table-column
                      prop="id"
                      label="Id"
                      width="50"
                    />

                    <el-table-column
                      prop="name"
                      label="Название"
                    />

                    <el-table-column
                      prop="price"
                      label="Цена"
                    />

                    <el-table-column
                      prop="min_total_for_free"
                      label="Минимальная сумма заказа"
                    />

                    <el-table-column
                      fixed="right"
                      label="Действия"
                      width="400">
                        <template slot-scope="scope">   
                            <el-button v-if="items[scope.$index].activity"
                               size="mini"
                               type="primary"
                               plain
                               @click="hideRow(scope.$index)">Скрыть</el-button>
                    <el-button v-if="!items[scope.$index].activity"
                               size="mini"
                               type="primary"
                               plain
                               @click="restoreRow(scope.$index)">Восстановить</el-button>                     
                          <el-button 
                            size="mini"
                            @click="updateRow(scope.$index)">Изменить</el-button>
                          
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer height="5%">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="paginator.total"
                        :current-page.sync="paginator.current_page"
                        :hide-on-single-page="true"
                        :page-size="paginator.per_page"
                        :page-count="paginator.last_page"
                        @current-change="getPage(paginator.current_page)"
                >
                </el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../../composable/config/regions-sort.config"
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
    name: "TransportCompanies",
    data: function (){
        return {
            sortConfig,
            items:[],
            paginator: [],
            query:{
                q:'',
                sort: sortConfig[0].field,
                page: 1,
            }
        }
    },
    computed: {
        activeSort() {
            const result = this.sortConfig.find((e) => e.field === this.query.sort)
            return result ? result.options  : undefined
        },
    },
    mounted() {
      this.initParams(this.$route.query);
      this.fetch(this.getQuery(this.$route.query));        
    },
    watch:{
    '$route.query'(v){   
        const query = this.getQuery(v)   
        if (query){              
          this.fetch(query)
        }
      }
    },
    methods:{
        fetch: async function(query) {          
          this.$store.commit(SETPRELOADER_STATE, true)
          this._fetch(query)
          .then()
          .catch()
          .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
          
        },

        _fetch: async function (query = ''){   
          try {
            const response = await axios.get('transport-company' + query)
            this.items = response.data.data;
              this.paginator = response.data?.meta;
          } catch(e)                 {
            if(e.response.status === 401){
                this.$router.push('/login');
            }
          }                  
        },
        getPage: function(pageNum){
          if(pageNum){
            this.query.page = pageNum
            this.setQuery()
          }
        },
        goToPage: function (path){
            this.$router.push(path);
        },
        hideRow: function (index) {
          let id = this.items[index].id;
          axios.post('transport-company/'+id+'/hide').then(()=>{
              this.$notify.success('Транспортная компания скрыта')
              this._fetch();
          }).catch((errors)=>{
              if(errors.response.status === 401){
                  this.$router.push('/login');
              }
          });
        },
        restoreRow: function (index) {
          let id = this.items[index].id;
          axios.post('transport-company/'+id+'/restore').then(()=>{
            this.$notify.success('Транспортная компания восстановлена')
            this._fetch();
          }).catch((errors)=>{
            if(errors.response.status === 401){
              this.$router.push('/login');
            }
          });
        },       
        updateRow: function (index) {
          let id = this.items[index].id;
          this.$router.push('/transport-companies/'+id + '/edit');
        },

        setQueryReset(){
          this.query.page = 1
          this.setQuery()
        },
        setQuery(){
          const result = {};
          let isChange = false;
          
          if (this.activeSort) {
            isChange = true;
            result['sort']= {
                by: this.activeSort.by,
                order: this.activeSort.order
            }      
          }
          if (this.query.q) {
            isChange = true;
            result['q']=this.query.q
          }
          if(this.query.page){
            isChange = true
            result['page']=this.query.page
          }

          if (isChange) {
            const q = this.getQuery(result)
            this.$router.push({
              path: 'transport-companies' + q,
            })
          }
        }, 
        getQuery(query) {
          if (Object.keys(query).length > 0){        
            const qs = require('qs');
            return `?${qs.stringify(query)}`
          }
          return ''
        },
        initParams(query){
          if (!query){
            return
          }
          const qs = require('qs');
          const parseQuery= qs.parse(query);

          if (parseQuery.sort?.by && parseQuery.sort?.order) {
            this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
          }
          if (parseQuery.q){
            this.query.q = parseQuery.q
          }
          if(parseQuery.page){
            this.query.page= parseQuery.page
          }
        }
    }
}
</script>